import type { ReactNode } from "react";
import { Tooltip } from "antd";

export function IconBtn({
  label,
  onClick,
  children,
  hintOpen,
}: {
  label: string;
  onClick: () => void;
  children: ReactNode;
  hintOpen?: boolean;
}) {
  return (
    <Tooltip title={label} mouseLeaveDelay={0} open={hintOpen}>
      <button
        type="button"
        aria-label={label}
        onClick={onClick}
        className="flex size-8 cursor-pointer items-center justify-center rounded-md border-none bg-transparent text-base text-accent transition-colors hover:bg-fill"
      >
        {children}
      </button>
    </Tooltip>
  );
}
